/**
 * Phase 6 · the deal screens' strings — the `record` part: the *Áttekintés* tab, its activity
 * feed, and the won / lost / next-step dialogs. Spread into `HU` and `EN` in `../catalogue.ts`; a
 * key in one and not the other is a type error there.
 */
export const HU = {
  /* ── the composer ── */
  'dealOverview.composer.label': 'Új bejegyzés',
  'dealOverview.composer.note': 'Jegyzet',
  'dealOverview.composer.task': 'Feladat',
  'dealOverview.composer.call': 'Hívás',
  'dealOverview.composer.email': 'E-mail',
  'dealOverview.composer.next': 'Következő lépés',
  'dealOverview.composer.notePlaceholder': 'Írj egy jegyzetet a dealről.',
  'dealOverview.composer.taskTitle': 'Feladat címe',
  'dealOverview.composer.taskBody': 'Mit kell megtenni?',
  'dealOverview.composer.callTitle': 'Miről szólt a hívás?',
  'dealOverview.composer.emailTitle': 'Az e-mail tárgya',
  'dealOverview.composer.commBody': 'Mi hangzott el, miben maradtatok?',
  'dealOverview.composer.participants': 'Résztvevők, pl. Nagy Réka, Tóth Balázs',
  'dealOverview.composer.due': 'Határidő',
  'dealOverview.composer.assignee': 'Felelős',
  'dealOverview.composer.saveNote': 'Jegyzet mentése',
  'dealOverview.composer.saveTask': 'Feladat felvétele',
  'dealOverview.composer.saveCall': 'Hívás rögzítése',
  'dealOverview.composer.saveEmail': 'E-mail rögzítése',
  'dealOverview.composer.empty': 'Írj valamit, mielőtt mented.',

  /* ── the left column ── */
  'dealOverview.next.title': 'Következő lépés',
  'dealOverview.next.empty': 'Nincs következő lépés — vedd fel a fenti választóval.',
  'dealOverview.next.emptyReadOnly': 'Nincs következő lépés.',
  'dealOverview.next.done': 'Következő lépés késznek jelölése',
  'dealOverview.next.edit': 'Következő lépés szerkesztése',
  'dealOverview.next.unassigned': 'Nincs felelős',
  'dealOverview.todos.title': 'Teendők',
  'dealOverview.todos.empty': 'Nincs nyitott teendő.',
  'dealOverview.todos.done': 'Késznek jelölés: {title}',
  'dealOverview.files.title': 'Fájlok',
  'dealOverview.files.empty': 'Nincs fájl a dealen.',

  /* ── the banners ── */
  'dealOverview.banner.won': 'Megnyert',
  'dealOverview.banner.lost': 'Elvesztett',
  'dealOverview.banner.converted': 'Létrejött:',
  'dealOverview.banner.project': 'Projekt: {name}',
  'dealOverview.banner.contract': 'Szerződés: {name}',

  /* ── the rail ── */
  'dealOverview.rail.value': 'Érték',
  'dealOverview.rail.weighted': 'súlyozva {value}',
  'dealOverview.rail.mode.label': 'Az érték forrása',
  'dealOverview.rail.mode.plan': 'projekttervből számolva',
  'dealOverview.rail.mode.indicative': 'indikatív ár',
  'dealOverview.rail.mode.pickIndicative': 'Indikatív ár',
  'dealOverview.rail.mode.pickIndicativeHint': 'egy összeg, kézzel megadva',
  'dealOverview.rail.mode.pickPlan': 'Projekttervből',
  'dealOverview.rail.mode.pickPlanHint': 'a deal sortételeinek összege',
  'dealOverview.rail.indicative': 'Indikatív érték',
  'dealOverview.rail.chance': 'Esély',
  'dealOverview.rail.probability': 'Valószínűség',
  'dealOverview.rail.forecast': 'Forecast',
  'dealOverview.rail.forecastAuto': 'Automatikus',
  'dealOverview.rail.forecastAutoHint': 'a valószínűségből számolva',
  'dealOverview.rail.forecastOverridden': 'kézzel felülírva',
  'dealOverview.rail.close': 'Zárás',
  'dealOverview.rail.slipReason': 'Miért csúszik?',
  'dealOverview.rail.slipPlaceholder': 'Pl. az ügyfél belső jóváhagyása késik.',
  'dealOverview.rail.slipHint': 'A csúszás oka naplózódik — ebből lesz a negyedév korai jelzése.',
  'dealOverview.rail.slipSave': 'Mentés',
  'dealOverview.rail.resource': 'Erőforrás',
  'dealOverview.rail.fullPlan': 'Teljes terv',
  'dealOverview.rail.placeholders': 'Placeholder',
  'dealOverview.rail.allocated': 'Σ allokált óra',
  'dealOverview.rail.planCost': 'Terv költség',
  'dealOverview.rail.planMargin': 'Terv margó',
  'dealOverview.rail.lines': 'Sortételek',
  'dealOverview.rail.toPlan': 'Terv',
  'dealOverview.rail.linesMore': '+{count} további sortétel',
  'dealOverview.rail.linesEmpty': 'Nincs sortétel',
  'dealOverview.rail.linesSum': 'Σ összeg',
  'dealOverview.rail.linesEstimate': 'Σ becslés',
  'dealOverview.rail.linesPeriod': 'Időszak',
  'dealOverview.rail.people': 'Résztvevők',
  'dealOverview.rail.contact': 'Kontakt',
  'dealOverview.rail.noContact': 'Nincs megadva',
  'dealOverview.rail.owner': 'Tulajdonos',
  'dealOverview.rail.followers': 'Követők',
  'dealOverview.rail.noFollowers': 'Nincs követő',
  'dealOverview.rail.searchPeople': 'Keresés névre…',
  'dealOverview.rail.details': 'Részletek',
  'dealOverview.rail.source': 'Forrás',
  'dealOverview.rail.campaign': 'Kampány',
  'dealOverview.rail.competitor': 'Versenytárs',
  'dealOverview.rail.tags': 'Címkék',
  'dealOverview.rail.tagsPlaceholder': 'vesszővel elválasztva',
  'dealOverview.rail.created': 'Létrehozva',

  /* ── the activity feed ── */
  'dealActivity.filter.label': 'Bejegyzések szűrése',
  'dealActivity.filter.all': 'Mind',
  'dealActivity.filter.notes': 'Jegyzetek',
  'dealActivity.filter.todos': 'Teendők',
  'dealActivity.filter.comm': 'Hívás / E-mail',
  'dealActivity.filter.system': 'Rendszer',
  'dealActivity.empty': 'Még nincs bejegyzés a dealen.',
  'dealActivity.emptyFiltered': 'Ebben a szűrőben nincs bejegyzés.',
  'dealActivity.participants': 'Résztvevők: {names}',
  'dealActivity.due': 'határidő: {date}',
  'dealActivity.done': 'kész',
  'dealActivity.delete': 'Bejegyzés törlése',
  'dealActivity.system.created': 'Deal létrehozva',
  'dealActivity.system.status': 'Státusz: {from} → {to}',
  'dealActivity.system.closeDate': 'Várható zárás: {from} → {to}',
  'dealActivity.system.won': 'Deal megnyerve — {value}',
  'dealActivity.system.lost': 'Deal elvesztve',
  'dealActivity.system.closedOn': 'Zárás dátuma: {date}',
  'dealActivity.system.reopened': 'Deal újranyitva — {to}',
  'dealActivity.system.scenarioWon': 'Nyertes scenario: {name}',
  'dealOverview.rail.currency.label': 'Pénznem',
  'dealOverview.rail.currency.hint': 'Az összeg nem számolódik át, csak a pénzneme változik.',
  'dealActivity.system.scenarioWonBody':
    'A terv sortételei, erőforrásai, órái és költségei ebből a scenarióból jöttek létre.',
  'dealActivity.system.generated': 'Generálva',
  'dealActivity.system.generatedProject': 'projekt',
  'dealActivity.system.generatedContract': 'szerződés: {contract}',
  'dealActivity.system.generatedContractPlain': 'szerződés',
  'dealActivity.system.generatedLineItems': 'sortételek: {count}',
  'dealActivity.system.generatedTasks': 'feladatok: {count}',
  'dealActivity.system.generatedAllocations': 'allokációk: {count}',
  'dealActivity.system.unknown': 'A deal megváltozott',

  /* ── the won dialog ── */
  'dealWon.title': 'Deal megnyerve',
  'dealWon.value': 'Tényleges érték',
  'dealWon.closedOn': 'Zárás dátuma',
  'dealWon.reason': 'Megnyerés oka',
  'dealWon.reasonNone': 'Nincs megadva',
  'dealWon.reasonHint': 'Opcionális — a win/loss elemzés ettől lesz kétoldalú.',
  'dealWon.note': 'Megjegyzés',
  'dealWon.notePlaceholder': 'Mi döntött?',
  'dealWon.generate': 'Folytatás a generálással',
  'dealWon.generateHint': 'Mentés után rögtön nyílik a projekt- és szerződés-generáló.',
  'dealWon.submit': 'Megnyert',
  'dealWon.errorDate': 'Add meg a zárás dátumát.',

  /* ── the lost dialog ── */
  'dealLost.title': 'Deal elvesztve',
  'dealLost.reason': 'Elvesztés oka',
  'dealLost.reasonPick': 'Válassz okot',
  'dealLost.reasonSearch': 'Keresés okra…',
  'dealLost.competitor': 'Versenytárs',
  'dealLost.competitorPlaceholder': 'Kihez ment?',
  'dealLost.closedOn': 'Zárás dátuma',
  'dealLost.note': 'Megjegyzés',
  'dealLost.notePlaceholder': 'Mi volt a valódi ok?',
  'dealLost.noteRequired': 'Ehhez az okhoz megjegyzés kell — különben a riport nem mond semmit.',
  'dealLost.errorReason': 'Válassz okot.',
  'dealLost.errorNote': 'Írd le röviden, mi történt.',
  'dealLost.submit': 'Elvesztett',

  /* ── the next-step dialog ── */
  'dealNext.title': 'Következő lépés',
  'dealNext.hint': 'Egy mozdulat és egy dátum — ez fogja meg a csendben elhaló dealeket.',
  'dealNext.text': 'Mi a következő lépés?',
  'dealNext.textPlaceholder': 'Pl. ütemterv egyeztetése a döntéshozóval',
  'dealNext.due': 'Határidő',
  'dealNext.assignee': 'Felelős',
  'dealNext.nobody': 'Nincs felelős',
  'dealNext.skip': 'Most nem',
  'dealNext.save': 'Mentés',
} as const;

export const EN: Record<keyof typeof HU, string> = {
  'dealOverview.composer.label': 'New entry',
  'dealOverview.composer.note': 'Note',
  'dealOverview.composer.task': 'Task',
  'dealOverview.composer.call': 'Call',
  'dealOverview.composer.email': 'Email',
  'dealOverview.composer.next': 'Next step',
  'dealOverview.composer.notePlaceholder': 'Write a note about the deal.',
  'dealOverview.composer.taskTitle': 'Task title',
  'dealOverview.composer.taskBody': 'What needs doing?',
  'dealOverview.composer.callTitle': 'What was the call about?',
  'dealOverview.composer.emailTitle': 'Email subject',
  'dealOverview.composer.commBody': 'What was said, and what did you agree?',
  'dealOverview.composer.participants': 'Participants, e.g. Réka Nagy, Balázs Tóth',
  'dealOverview.composer.due': 'Due date',
  'dealOverview.composer.assignee': 'Assignee',
  'dealOverview.composer.saveNote': 'Save note',
  'dealOverview.composer.saveTask': 'Add task',
  'dealOverview.composer.saveCall': 'Log call',
  'dealOverview.composer.saveEmail': 'Log email',
  'dealOverview.composer.empty': 'Write something before saving.',

  'dealOverview.next.title': 'Next step',
  'dealOverview.next.empty': 'No next step — add one with the picker above.',
  'dealOverview.next.emptyReadOnly': 'No next step.',
  'dealOverview.next.done': 'Mark the next step done',
  'dealOverview.next.edit': 'Edit the next step',
  'dealOverview.next.unassigned': 'Unassigned',
  'dealOverview.todos.title': 'To-dos',
  'dealOverview.todos.empty': 'No open to-dos.',
  'dealOverview.todos.done': 'Mark done: {title}',
  'dealOverview.files.title': 'Files',
  'dealOverview.files.empty': 'No files on this deal.',

  'dealOverview.banner.won': 'Won',
  'dealOverview.banner.lost': 'Lost',
  'dealOverview.banner.converted': 'Created:',
  'dealOverview.banner.project': 'Project: {name}',
  'dealOverview.banner.contract': 'Contract: {name}',

  'dealOverview.rail.value': 'Value',
  'dealOverview.rail.weighted': 'weighted {value}',
  'dealOverview.rail.mode.label': 'Where the value comes from',
  'dealOverview.rail.mode.plan': 'calculated from the plan',
  'dealOverview.rail.mode.indicative': 'indicative price',
  'dealOverview.rail.mode.pickIndicative': 'Indicative price',
  'dealOverview.rail.mode.pickIndicativeHint': 'one amount, entered by hand',
  'dealOverview.rail.mode.pickPlan': 'From the plan',
  'dealOverview.rail.mode.pickPlanHint': "the sum of the deal's line items",
  'dealOverview.rail.indicative': 'Indicative value',
  'dealOverview.rail.chance': 'Likelihood',
  'dealOverview.rail.probability': 'Probability',
  'dealOverview.rail.forecast': 'Forecast',
  'dealOverview.rail.forecastAuto': 'Automatic',
  'dealOverview.rail.forecastAutoHint': 'derived from the probability',
  'dealOverview.rail.forecastOverridden': 'set by hand',
  'dealOverview.rail.close': 'Close',
  'dealOverview.rail.slipReason': 'Why is it slipping?',
  'dealOverview.rail.slipPlaceholder': "E.g. the client's internal approval is late.",
  'dealOverview.rail.slipHint':
    "The reason is logged — it becomes the quarter's earliest warning sign.",
  'dealOverview.rail.slipSave': 'Save',
  'dealOverview.rail.resource': 'Resources',
  'dealOverview.rail.fullPlan': 'Full plan',
  'dealOverview.rail.placeholders': 'Placeholders',
  'dealOverview.rail.allocated': 'Σ allocated hours',
  'dealOverview.rail.planCost': 'Plan cost',
  'dealOverview.rail.planMargin': 'Plan margin',
  'dealOverview.rail.lines': 'Line items',
  'dealOverview.rail.toPlan': 'Plan',
  'dealOverview.rail.linesMore': '+{count} more line items',
  'dealOverview.rail.linesEmpty': 'No line items',
  'dealOverview.rail.linesSum': 'Σ amount',
  'dealOverview.rail.linesEstimate': 'Σ estimate',
  'dealOverview.rail.linesPeriod': 'Period',
  'dealOverview.rail.people': 'People',
  'dealOverview.rail.contact': 'Contact',
  'dealOverview.rail.noContact': 'Not set',
  'dealOverview.rail.owner': 'Owner',
  'dealOverview.rail.followers': 'Followers',
  'dealOverview.rail.noFollowers': 'No followers',
  'dealOverview.rail.searchPeople': 'Search by name…',
  'dealOverview.rail.details': 'Details',
  'dealOverview.rail.source': 'Source',
  'dealOverview.rail.campaign': 'Campaign',
  'dealOverview.rail.competitor': 'Competitor',
  'dealOverview.rail.tags': 'Tags',
  'dealOverview.rail.tagsPlaceholder': 'separated by commas',
  'dealOverview.rail.created': 'Created',

  'dealActivity.filter.label': 'Filter entries',
  'dealActivity.filter.all': 'All',
  'dealActivity.filter.notes': 'Notes',
  'dealActivity.filter.todos': 'To-dos',
  'dealActivity.filter.comm': 'Calls / Emails',
  'dealActivity.filter.system': 'System',
  'dealActivity.empty': 'Nothing has been logged on this deal yet.',
  'dealActivity.emptyFiltered': 'No entries match this filter.',
  'dealActivity.participants': 'Participants: {names}',
  'dealActivity.due': 'due {date}',
  'dealActivity.done': 'done',
  'dealActivity.delete': 'Delete entry',
  'dealActivity.system.created': 'Deal created',
  'dealActivity.system.status': 'Status: {from} → {to}',
  'dealActivity.system.closeDate': 'Expected close: {from} → {to}',
  'dealActivity.system.won': 'Deal won — {value}',
  'dealActivity.system.lost': 'Deal lost',
  'dealActivity.system.closedOn': 'Closed on {date}',
  'dealActivity.system.reopened': 'Deal reopened — {to}',
  'dealActivity.system.scenarioWon': 'Winning scenario: {name}',
  'dealOverview.rail.currency.label': 'Currency',
  'dealOverview.rail.currency.hint': 'The amount is not converted; only its currency changes.',
  'dealActivity.system.scenarioWonBody':
    "The plan's line items, resources, hours and costs were copied from this scenario.",
  'dealActivity.system.generated': 'Generated',
  'dealActivity.system.generatedProject': 'project',
  'dealActivity.system.generatedContract': 'contract {contract}',
  'dealActivity.system.generatedContractPlain': 'contract',
  'dealActivity.system.generatedLineItems': 'line items: {count}',
  'dealActivity.system.generatedTasks': 'tasks: {count}',
  'dealActivity.system.generatedAllocations': 'allocations: {count}',
  'dealActivity.system.unknown': 'The deal changed',

  'dealWon.title': 'Deal won',
  'dealWon.value': 'Actual value',
  'dealWon.closedOn': 'Close date',
  'dealWon.reason': 'Why we won',
  'dealWon.reasonNone': 'Not set',
  'dealWon.reasonHint': 'Optional — it is what makes the win/loss analysis two-sided.',
  'dealWon.note': 'Note',
  'dealWon.notePlaceholder': 'What decided it?',
  'dealWon.generate': 'Continue with generation',
  'dealWon.generateHint': 'The project and contract generator opens straight after saving.',
  'dealWon.submit': 'Won',
  'dealWon.errorDate': 'Enter the close date.',

  'dealLost.title': 'Deal lost',
  'dealLost.reason': 'Why we lost',
  'dealLost.reasonPick': 'Choose a reason',
  'dealLost.reasonSearch': 'Search reasons…',
  'dealLost.competitor': 'Competitor',
  'dealLost.competitorPlaceholder': 'Who won it?',
  'dealLost.closedOn': 'Close date',
  'dealLost.note': 'Note',
  'dealLost.notePlaceholder': 'What was the real reason?',
  'dealLost.noteRequired': 'This reason needs a note — otherwise the report says nothing.',
  'dealLost.errorReason': 'Choose a reason.',
  'dealLost.errorNote': 'Describe briefly what happened.',
  'dealLost.submit': 'Lost',

  'dealNext.title': 'Next step',
  'dealNext.hint': 'One action and one date — this is what catches deals that quietly die.',
  'dealNext.text': 'What is the next step?',
  'dealNext.textPlaceholder': 'E.g. agree the schedule with the decision-maker',
  'dealNext.due': 'Due date',
  'dealNext.assignee': 'Assignee',
  'dealNext.nobody': 'Unassigned',
  'dealNext.skip': 'Not now',
  'dealNext.save': 'Save',
};
